import { i18n } from '@/common/utils/i18n'
import VueI18n from '@/i18n/locale'

// 新增商机状态
export const BIZOPP_IN_PROCESS_STATUS = 1
export const BIZOPP_SUCCESS_STATUS = 2
export const BIZOPP_FAILED_STATUS = 3

// 商家类型
export const BIZOPP_TYPE_ORDINARY = 1 // 普通商家
export const BIZOPP_TYPE_CKA = 2 // 城市KA
export const BIZOPP_TYPE_KA = 3 // KA商家

// 商机状态
export const BIZOPP_STATUS_NORMAL = 1 // 跟进中
export const BIZOPP_STATUS_TO_SUBMIT = 2 // 待提交
export const BIZOPP_STATUS_AUTH = 3 // 开店审核中
export const BIZOPP_STATUS_AUTH_FAILURE = 4 // 审核失败
export const BIZOPP_STATUS_SIGINED = 5 // 已签约
export const BIZOPP_STATUS_INVALID = 6 // 无效
export const BIZOPP_STATUS_AUTH_SUCCESS = 8 // 审核通过
// export const TAGS_MAP = {
//   '0': '正常门店',
//   '1': '重复门店',
//   '2': '找不到门店',
//   '3': '店铺停业'
// }

// 在线状态状态
export const BIZ_STATUS = {
  1: i18n.gettext('在线'),
  2: i18n.gettext('不在线'),
  3: i18n.gettext('封禁'),
}

// 管控状态
export const SHOP_STATUS = {
  1: i18n.gettext('正常'),
  2: i18n.gettext('正常'),
  3: i18n.gettext('封禁'),
}

export const DELIVERY_LIST = [
  {
    label: i18n.gettext('平台配送'),
    value: '1',
  },
  {
    label: i18n.gettext('自配送'),
    value: '2',
  },
]

export const PLATFORM_OPTIONS = [
  {
    label: 'Uber Eats',
    value: 'ubereats',
  },
  {
    label: 'SinDelantal',
    value: 'sindelantal',
  },
  {
    label: 'TripAdvisor',
    value: 'tripadvisor',
  },
  {
    label: 'Foursquare',
    value: 'foursquare',
  },
  {
    label: 'Rappi',
    value: 'rappi',
  },
  {
    label: i18n.gettext('自配送'),
    value: 'delivery',
  },
]

export const BIZOPP_STATUS_OPTIONS = [
  {
    label: i18n.gettext('跟进中'),
    value: 1,
  },
  {
    label: i18n.gettext('草稿中'),
    value: 2,
  },
  {
    label: i18n.gettext('审批中'),
    value: 3,
  },
  {
    label: i18n.gettext('审批失败'),
    value: 4,
  },
  {
    label: i18n.gettext('已签约'),
    value: 5,
  },
  {
    label: i18n.gettext('无效'),
    value: 6,
  },
  {
    label: i18n.gettext('审批通过'),
    value: 8,
  },
  {
    label: i18n.gettext('已核准'),
    value: 9,
  },
  {
    label: i18n.gettext('已签章'),
    value: 10,
  },
]
// 单纯的列表筛选条件
export const SHOP_FILTER_OPTIONS = [
  {
    label: i18n.gettext('全部'),
    value: 'status:-1',
  },
  {
    label: i18n.gettext('跟进中'),
    value: 'status:1',
  },
  {
    label: i18n.gettext('草稿中'),
    value: 'status:2',
  },
  {
    label: i18n.gettext('审批中'),
    value: 'status:3',
  },
  {
    label: i18n.gettext('审批失败'),
    value: 'status:4',
  },
  {
    label: i18n.gettext('审批通过'),
    value: 'status:8',
  },
  {
    label: i18n.gettext('已核准'),
    value: 'status:9',
  },
  {
    label: i18n.gettext('已签章'),
    value: 'status:10',
  },
  {
    label: i18n.gettext('已签约'),
    value: 'status:5',
  },
]
export const PARTY_STATUS_OPTIONS = [
  {
    label: i18n.gettext('草稿中'),
    value: 0,
  },
  {
    label: i18n.gettext('审批中'),
    value: 1,
  },
  {
    label: i18n.gettext('审批失败'),
    value: 2,
  },
  {
    label: i18n.gettext('审批通过'),
    value: 5,
  },
  {
    label: i18n.gettext('已核准'),
    value: 6,
  },
  {
    label: i18n.gettext('已签章'),
    value: 7,
  },
  {
    label: i18n.gettext('已签约'),
    value: 3,
  },
  {
    label: i18n.gettext('无效'),
    value: 4,
  },
]
// export const SHOP_TYPE_MAP = {
//   '1': '普通',
//   '2': 'CKA',
//   '3': 'KA'
// }

export const BIZOPP_RANK_OPTIONS = [
  {
    label: 'S',
    value: 1,
  },
  {
    label: 'A',
    value: 2,
  },
  {
    label: 'B',
    value: 3,
  },
  {
    label: 'C',
    value: 4,
  },
  {
    label: 'U',
    value: 5,
  },
  // 删除P等级，这里商机统一去掉此等级
  // {
  //   label: 'P',
  //   value: 6
  // }
]

export const BIZOPP_FILTER_TYPE_OPTIONS = [
  {
    label: i18n.gettext('全部门店'),
    value: -1,
  },
  {
    label: i18n.gettext('正常门店'),
    value: 0,
  },
]

export const BIZOP_HIGHERPRICE_OPTIONS = [
  {
    label: i18n.gettext('是'),
    value: 1,
  },
  {
    label: i18n.gettext('否'),
    value: 0,
  },
]

// 业务模式
export const BUSINESS_MODEL_LIST = [
  {
    text: VueI18n.t('FoodOpB_crm_Takeaway_mode_UxEG' /** 外卖模式 */),
    value: 1,
  },
  {
    text: VueI18n.t('Gattaran_Grocery__pKzk' /** 商超模式 */),
    value: 3,
  },
]

export const CHANNEL_TYPE_LIST = [
  {
    text: i18n.gettext('是'),
    value: 1,
  },
  {
    text: i18n.gettext('否'),
    value: 0,
  },
]

// checkCityAndPoi接口使用 为了区分提交poi时的操作类型
export const CHECK_POI_CREATE = 1 // 新建&编辑商机
export const CHECK_POI_EDIT = 1 // 新建&编辑商机
export const CHECK_POI_ODNORY_SIGN = 2 // 普通商家申请签约
export const CHECK_POI_KA_CKA_SIGN = 3 // KACKA申请签约
export const CHECK_POI_MODIFY_ADDRESS = 3 // 修改地址
export const CHECK_POI_MSG_COLLECT = 3 // 修改地址

export const BIZ_STATUS_OPTIONS = [
  {
    value: '1',
    label: i18n.gettext('正常经营'),
  },
  {
    value: '2',
    label: i18n.gettext('暂停经营'),
  },
  {
    value: '10',
    label: i18n.gettext('歇业中'),
  },
  {
    value: '3',
    label: i18n.gettext('封禁中'),
  },
]
export const AUDIT_CODE = {
  AUDIT_ABSOLUTE_REPEAT: 20579, // 不满足系统判重
  AUDIT_SIMILAR: 20575, // 不满足相似度校验
  AUDIT_SUCCESS: 0, // 成功
}

export const SHOP_SUBSIDY_ACTIVE_OPTIONS = [
  {
    label: i18n.gettext('否'),
    value: 0,
  },
  {
    label: i18n.gettext('是'),
    value: 1,
  },
  {
    label: '/',
    value: 2,
  },
]
